export const SET_PROJECT_SITES = 'SET_PROJECT_SITES';
export const SET_PROJECT_AREAS = 'SET_PROJECT_AREAS';
export const SET_SHOW_ADD_SITE_MODAL = 'SET_SHOW_ADD_SITE_MODAL';
export const SET_SHOW_ADD_AREA_MODAL = 'SET_SHOW_ADD_AREA_MODAL';
